/* 后台管理系统路由配置 */

/* layout */
import Layout from '@/views/admin/common/layout'

/* 机构认证 */
const ArtIdentify = () =>
  import(/* webpackChunkName: "admin-artidentify" */ '@/views/admin/artIdentify/artIdentify')

/* 文章 */
const Article = () =>
  import(/* webpackChunkName: "admin-article" */ '@/views/admin/article/article')
const ArticleEdit = () =>
  import(/* webpackChunkName: "admin-article" */ '@/views/admin/article/articleEdit')

/* 展览 */
const Exhibition = () =>
  import(/* webpackChunkName: "admin-exhibition" */ '@/views/admin/exhibition/exhibition')
const ExhibitionEdit = () =>
  import(/* webpackChunkName: "admin-exhibition" */ '@/views/admin/exhibition/exhibitionEdit')

/* 作品 */
const Works = () =>
  import(/* webpackChunkName: "admin-works" */ '@/views/admin/works/works')
const WorksEdit = () =>
  import(/* webpackChunkName: "admin-works" */ '@/views/admin/works/works')

/* 验票管理 */
const InspectTicket = () =>
  import(/* webpackChunkName: "admin-ticket" */ '@/views/admin/ticket/inspectTicket')

/* 订单管理 */
const Order = () =>
  import(/* webpackChunkName: "admin-order" */ '@/views/admin/order/orderList')
const OrderDetail = () =>
  import(/* webpackChunkName: "admin-order" */ '@/views/admin/order/orderDetail')

/* 销售统计 */
const Volume = () =>
  import(/* webpackChunkName: "admin-volume" */ '@/views/admin/volume/volumeList')

/* 商品列表 */
const GoodList = () =>
  import(/* webpackChunkName: "admin-volume" */ '@/views/admin/good/goodList')

/* 商品详情 */
const GoodDetail = () =>
  import(/* webpackChunkName: "admin-volume" */ '@/views/admin/good/goodDetail')

const routes = [
  {
    path: '/admin',
    redirect: '/admin/article'
  },
  {
    path: '/artidentify',
    component: ArtIdentify
  },
  {
    path: '/admin/article',
    component: Layout,
    children: [
      { path: '', component: Article },
      { path: 'add', component: ArticleEdit },
      { path: 'edit/:id', component: ArticleEdit }
    ]
  },
  {
    path: '/admin/exhibition',
    component: Layout,
    children: [
      { path: '', component: Exhibition },
      { path: 'add', component: ExhibitionEdit },
      { path: 'edit/:id', component: ExhibitionEdit }
    ]
  },
  {
    path: '/admin/works',
    component: Layout,
    children: [
      { path: '', component: Works },
      { path: 'add', component: WorksEdit },
      { path: 'edit/:id', component: WorksEdit }
    ]
  },
  {
    path: '/admin/ticket',
    component: Layout,
    children: [{ path: 'inspectTicket', component: InspectTicket }]
  },
  {
    path: '/admin/order',
    component: Layout,
    children: [
      { path: '', component: Order },
      { path: 'detail/:id', component: OrderDetail }
    ]
  },
  {
    path: '/admin/volume',
    component: Layout,
    children: [{ path: '', component: Volume }]
  },
  {
    path: '/admin/good',
    component: Layout,
    children: [
      { path: '', component: GoodList },
      { path: 'detail/:id', component: GoodDetail }
    ]
  }
]

export default routes
